import ScormAPI2004 from '@/lib/ScormApi/ScormAPI2004'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import InteractionsObjectInterface, { InteractionsObjectType } from "@/lib/ScormApi/Scorm2004/interfaces/InteractionsObjectInterface"

export default function InteractionsObject (api: ScormAPI2004): InteractionsObjectInterface {
  let _id = ''
  let _type = InteractionsObjectType.NONE
  let _timestamp = ''
  let _weighting = ''
  let _learner_response = ''
  let _result = ''
  let _latency = ''
  let _description = ''

  return {
    get id () {
      return _id
    },
    set id (id) {
      _id = id
    },
    get type () {
      return _type
    },
    set type (type) {
      _type = type
    },
    get timestamp () {
      return _timestamp
    },
    set timestamp (timestamp) {
      _timestamp = timestamp
    },
    get weighting () {
      return _weighting
    },
    set weighting (weighting) {
      _weighting = weighting
    },
    get learner_response () {
      return _learner_response
    },
    set learner_response (learner_response) {
      _learner_response = learner_response
    },
    get result () {
      return _result
    },
    set result (result) {
      _result = result
    },
    get latency () {
      return _latency
    },
    set latency (latency) {
      _latency = latency
    },
    get description () {
      return _description
    },
    set description (description) {
      _description = description
    },
    objectives: {
      childArray: [],
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        api.throwSCORMError(404)
      },
      toJSON: new JsonFormatter().apply
    },
    correct_responses: {
      childArray: [],
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        api.throwSCORMError(404)
      },
      toJSON: new JsonFormatter().apply
    },
    toJSON: new JsonFormatter().apply
  }
}
